module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.0a96d232.woff";